import { type ReactNode } from 'react';

import { Map } from '@/microfrontends/map/shared';

import { MapBanners } from '@/packages/MapBanners';
import { useUserQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';
import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';

import { useApplicationContext } from '../../context/ApplicationContext';
import { useElementsRefContext } from '../../context/ElementsRefContext';

import { MapLayout } from './internal/components/MapLayout';
import { useCalculateMapSizes } from './internal/hooks/useCalculateMapSizes';

export function MapLayoutContainer(): ReactNode {
  const context = useApplicationContext();

  const { mapContainerRef } = useElementsRefContext();

  const { data: user } = useUserQuery();

  const jsonQuery = useFiltersSelector();

  const { isFetching } = useGetClustersQuery();

  useCalculateMapSizes();

  return (
    <MapLayout
      banners={<MapBanners jsonQuery={jsonQuery} userIsAgent={user?.isAgent} />}
      disabled={isFetching}
      map={<Map context={context} />}
      ref={mapContainerRef}
    />
  );
}
